import { motion } from 'framer-motion'
import React, { useEffect, useMemo, useState } from 'react'
import API from '../../Common/API'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import FieldInput from '../../Components/FieldInput'
import { useDispatch } from 'react-redux'
import { setAlert } from '../../Store/Theme/actions'

const initialValues = {
    firstName: "",
    lastName: '',
    userName: '',
    address: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        district: '',
        landMark: '',
        state: '',
        pinCode: ''
    },
    gender: "",
    mobileNumber: "",
    email: ""
}

const Profile = () => {

    const [userDetails, setUserDetails] = useState()
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()
    const [addressEdit, setAddressEdit] = useState(false)

    const formData = useMemo(() => {
        return { ...initialValues, ...userDetails }
    }, [userDetails])

    useEffect(() => {
        API.get('/users/getUserDetails').then((profRes) => {
            if (profRes.status === 200) {
                setUserDetails(profRes.data.data)
                if (profRes.data.data.address && profRes.data.data.address._id) {
                    setAddressEdit(true)
                }
                setLoading(false)
            }
        })
    }, [])

    const profileFormSchema = Yup.object().shape({
        firstName: Yup.string().required("First name is required"),
        lastName: Yup.string().required("Last name is required"),
        userName: Yup.string().nullable(),
        address: Yup.object().shape({
            addressLine1: Yup.string().required("Address line 1 is required"),
            addressLine2: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            district: Yup.string().required("District is required"),
            landMark: Yup.string().nullable(),
            state: Yup.string().required("State is required"),
            pinCode: Yup.string().required("Pin Code is required"),
        }),
        // gender: Yup.string().required("Gender is required"),
        mobileNumber: Yup.string().required("Mobile number is required"),
        email: Yup.string().required("Email is required")
    })

    const profileForm = useFormik({
        initialValues: formData,
        validateOnMount: true,
        enableReinitialize: true,
        validationSchema: profileFormSchema,
        onSubmit: (values) => {
            console.log(values)
            API.post('/users/updateUser', values).then((profileRes) => {
                if (profileRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Profile Updated Successfully', active: true, type: 'success' }))
                }
            })
        }
    })

    const getLocation = (value) => {
        if (value.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${value}`).then((pinRes) => {
                if (pinRes.status === 200) {
                    const location = pinRes.data.data
                    profileForm.setValues({ ...profileForm.values, address: { city: location?.city || '', district: location?.district || '', pinCode: location?.pinCode || '', state: location?.state || '' } })
                    setAddressEdit(true)
                }
            })
        } else if (value.length === 0) {
            profileForm.setValues({ ...profileForm.values, address: { city: '', district: '', pinCode: '', state: '', addressLine1: '', addressLine2: '' } })
            setAddressEdit(false)
        }
    }

    return (
        <motion.div className="w-full bg-white text-[#002557] px-20 py-10 h-full items-center justify-center relative flex flex-col">
            <motion.div className="w-full bg-white drop-shadow-md my-2 text-[#002557]">
                <p className="font-bold px-2 py-2">Personal Information</p>
                <motion.div className="grid grid-cols-2 w-full gap-5">
                    <FieldInput label={"First Name"} fieldProps={profileForm.getFieldProps('firstName')} fieldHelper={profileForm.getFieldHelpers('firstName')} fieldMeta={profileForm.getFieldMeta('firstName')} edit={true} dataLoaded={true} />
                    <FieldInput label={"Last Name"} fieldProps={profileForm.getFieldProps('lastName')} fieldHelper={profileForm.getFieldHelpers('lastName')} fieldMeta={profileForm.getFieldMeta('lastName')} edit={true} dataLoaded={true} />
                    <FieldInput label={"User Name"} fieldProps={profileForm.getFieldProps('userName')} fieldHelper={profileForm.getFieldHelpers('userName')} fieldMeta={profileForm.getFieldMeta('userName')} edit={false} dataLoaded={true} />
                    <FieldInput label={"Mobile Number"} fieldMeta={profileForm.getFieldMeta('mobileNumber')} fieldHelper={profileForm.getFieldHelpers('mobileNumber')} fieldProps={profileForm.getFieldProps('mobileNumber')} edit={true} dataLoaded={true} />
                    <FieldInput label={"Email Id"} fieldMeta={profileForm.getFieldMeta('email')} fieldHelper={profileForm.getFieldHelpers('email')} fieldProps={profileForm.getFieldProps('email')} edit={true} dataLoaded={true} />
                </motion.div>
            </motion.div>
            <motion.div className="w-full bg-white drop-shadow-md my-2 text-[#002557]">
                <p className="font-bold px-2 py-2">Address Information</p>
                <motion.div className="grid grid-cols-2 w-full gap-5">
                    <FieldInput label={"Pin Code"} fieldMeta={profileForm.getFieldMeta('address.pinCode')} fieldHelper={profileForm.getFieldHelpers('address.pinCode')} fieldProps={profileForm.getFieldProps('address.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                    <FieldInput label={"Address Line1"} fieldMeta={profileForm.getFieldMeta('address.addressLine1')} fieldHelper={profileForm.getFieldHelpers('address.addressLine1')} fieldProps={profileForm.getFieldProps('address.addressLine1')} edit={addressEdit} dataLoaded={true} />
                    <FieldInput label={"Address Line2"} fieldMeta={profileForm.getFieldMeta('address.addressLine2')} fieldHelper={profileForm.getFieldHelpers('address.addressLine2')} fieldProps={profileForm.getFieldProps('address.addressLine2')} edit={addressEdit} dataLoaded={true} />
                    <FieldInput label={"City"} fieldMeta={profileForm.getFieldMeta('address.city')} fieldHelper={profileForm.getFieldHelpers('address.city')} fieldProps={profileForm.getFieldProps('address.city')} edit={addressEdit} dataLoaded={true} />
                    <FieldInput label={"District"} fieldMeta={profileForm.getFieldMeta('address.district')} fieldHelper={profileForm.getFieldHelpers('address.district')} fieldProps={profileForm.getFieldProps('address.district')} edit={addressEdit} dataLoaded={true} />
                    <FieldInput label={"Landmark"} fieldMeta={profileForm.getFieldMeta('address.landmark')} fieldHelper={profileForm.getFieldHelpers('address.landmark')} fieldProps={profileForm.getFieldProps('address.landmark')} edit={addressEdit} dataLoaded={true} />
                    <FieldInput label={"State"} fieldMeta={profileForm.getFieldMeta('address.state')} fieldHelper={profileForm.getFieldHelpers('address.state')} fieldProps={profileForm.getFieldProps('address.state')} edit={addressEdit} dataLoaded={true} />
                </motion.div>
            </motion.div>
            <motion.div className="w-full flex flex-row justify-center">
                <motion.div className="bg-[#002557] px-2 py-1 cursor-pointer rounded-full flex flex-row justify-center w-52 text-white font-bold" onClick={() => profileForm.submitForm()}>
                    Update
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default Profile